import RestService from '@/modules/backend/RestService';
import { Resource } from '@/modules/backend/Entities/Resource';
import { plainToClass } from 'class-transformer';

/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Resources
 */
export class Resources {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async GetAll(): Promise<Resource> {
    const items = await this.rest.get('/api/v1/resources');

    return plainToClass(Resource, items);
  }
}
